import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Building2, Loader2, ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

export default function AdminParceiros() {
  const navigate = useNavigate();
  const { data: orgs, isLoading } = useQuery({
    queryKey: ["admin_partner_orgs"],
    queryFn: async () => {
      const { data, error } = await supabase.from("partner_orgs").select("*").order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div className="p-8 flex items-center justify-center min-h-[50vh]"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
  }

  return (
    <div className="p-8 max-w-6xl">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="font-heading text-2xl font-bold text-foreground">Parceiros Ativos</h1>
        <p className="text-muted-foreground text-sm mt-1">{orgs?.length ?? 0} organizações parceiras</p>
      </motion.div>

      <div className="mt-6 space-y-3">
        {(orgs ?? []).map((org, i) => (
          <motion.div
            key={org.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * i }}
            onClick={() => navigate(`/admin/parceiros/${org.id}`)}
            className="bg-card rounded-2xl p-5 border border-border cursor-pointer hover:border-primary/30 hover:shadow-sm transition-all"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center">
                  <Building2 className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground">{org.name}</h3>
                  {org.industry && <Badge variant="outline" className="text-xs mt-1">{org.industry}</Badge>}
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-muted-foreground" />
            </div>
          </motion.div>
        ))}
        {(orgs ?? []).length === 0 && (
          <div className="bg-muted/50 rounded-2xl p-12 text-center">
            <Building2 className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="font-heading font-semibold text-foreground mb-2">Nenhum parceiro ativo</h3>
          </div>
        )}
      </div>
    </div>
  );
}
